import CardWithLogo from './cardWithLogo';
import Header from './header';
import Footer from './footer';

CardWithLogo.Header = Header;
CardWithLogo.Footer = Footer;

export default CardWithLogo;
